import { memo } from 'react';
import { Typography } from '@mui/material';

import { appVersion } from '../../const/commonConst';
import theme from '../../../theme';

/**
 * アプリバージョン
 */
const AppVersion = () => {
	return (
		<Typography
			noWrap
			role="lable"
			aria-label={appVersion}
			sx={{
				fontSize: 15,
				fontWeight: 'bold',
				color: theme.palette.common.white,
				marginLeft: 3,
				flexGrow: 1,
			}}
		>
			{appVersion}
		</Typography>
	);
};

export default memo(AppVersion);
